/**
 * Aparelho sem mouse (celular, tablet) — spec 024. No celular a escuta usa
 * sempre o motor próprio e a impressão sai sempre pela própria página (sem
 * aba nova). Avaliado uma vez ao carregar.
 */
export const CELULAR =
  typeof window !== 'undefined' && !!window.matchMedia && !window.matchMedia('(pointer: fine)').matches;
